export default function ProgramHighlights() {
  const highlights = [
    {
      icon: 'ri-sailboat-line',
      title: 'Sunset Yacht Experience',
      description: '2-stündige Luxus-Yachtfahrt entlang Dubai Marina, JBR und Palm Jumeirah mit goldenem Sonnenuntergang'
    },
    {
      icon: 'ri-building-line',
      title: 'Seminar im Burj Al Arab',
      description: 'Exklusiver Konferenzraum im legendären 7-Sterne-Hotel mit atemberaubendem Meerblick.'
    },
    {
      icon: 'ri-car-line',
      title: 'Investment City Tour',
      description: 'Geführte Tour durch Top-Freezones, erfolgreiche Immobilienprojekte und Zukunftsprojekte'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Emirate-Tour',
      description: 'Ganztägige Tour durch Umm Al Quwain, Ajman und Ras Al Khaimah mit Freezone-Besichtigungen'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Fine-Dining Experiences',
      description: 'Exklusive Restaurants: Burj Al Arab, Atlantis The Royal und traditionelles Wüstencamp'
    },
    {
      icon: 'ri-user-line',
      title: 'Individuelle Beratung',
      description: '1-zu-1 Expertengespräche für Immobilien, Unternehmensgründung und Steueroptimierung'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Programm-<span className="text-blue-600">Highlights</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Fünf Tage voller exklusiver Erlebnisse, Business-Insights und Networking mit erfolgreichen Investoren.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {highlights.map((highlight, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-blue-100 h-full flex flex-col">
              <div className="bg-blue-50 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className={`${highlight.icon} text-blue-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-blue-600 text-center leading-tight">{highlight.title}</h3>
              <p className="text-gray-600 leading-relaxed text-center flex-grow">{highlight.description}</p>
            </div>
          ))}
        </div>

        {/* Special Highlight */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-3xl p-12 text-white text-center shadow-2xl">
          <div className="text-6xl mb-6">🏆</div>
          <h3 className="text-3xl md:text-4xl font-bold mb-6">Exklusiver Zugang garantiert</h3>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            Dank unserer Dubai-Insider erhalten Sie Zugang zu speziellen Bereichen und Locations, 
            die der Öffentlichkeit normalerweise verschlossen bleiben.
          </p>
        </div>
      </div>
    </section>
  );
}